import styled from "styled-components"
import { theme } from "@aistihealth/web-common/src/util/styles/theme"

export interface InputLabelProps {
  inline?: boolean
}

export const InputLabel = styled.label<InputLabelProps>`
  ${theme.textStyle("default", "medium", "normal")}
  display: ${({ inline }) => (inline ? "inline" : "block")};
  color: ${theme.colors.primary};
`
